module.exports = __webpack_public_path__ + "media/images/jim-bev-ec3256a44abb0272593a9d189c889d68.jpg";